const PROJECT_LIST = {
  right: [
    {
      screen_position: "right",
      project_name: "Rehabit",
      thumbnail_image: "P_RE_thumbnail.svg",
      role: "Product Design",
      year: "2021",
      url: "rehabit",
    },
    {
      screen_position: "right",
      project_name: "Bium_Intermittent fasting",
      thumbnail_image: "P_BI_featured.png",
      role: "Product Design",
      year: "2020",
      url: "bium",
    },
    {
      screen_position: "right",
      project_name: "Milk UI",
      thumbnail_image: "P_milkui_featured.svg",
      role: "UI library",
      year: "2019",
      url: "milk-ui",
    },
    {
      screen_position: "right",
      project_name: "Magic table",
      thumbnail_image: "P_mgtb_featured.png",
      role: "Product design, UI library",
      year: "2018",
      url: "mgtable",
    },
    {
      screen_position: "right",
      project_name: "Hair schedule",
      thumbnail_image: "P_HS_featured2.jpg",
      role: "UX/UI design, Branding",
      year: "2015",
      url: "hair-schedule",
    },
    {
      screen_position: "right",
      project_name: "9 o'clock",
      thumbnail_image: "P_9_featured.jpg",
      role: "Branding",
      year: "2010",
      url: "nine-o-clock",
    },
    {
      screen_position: "right",
      project_name: "Save earth",
      thumbnail_image: "P_SE_featured.jpg",
      role: "Visual artwork, Branding",
      year: "2009",
      url: "save-earth",
    },
    {
      screen_position: "right",
      project_name: "Dove world",
      thumbnail_image: "P_dove_featured.jpg",
      role: "Visual artwork",
      year: "2007",
      url: "dove",
    },
  ],
  left: [
    {
      screen_position: "left",
      project_name: "TeleRehab",
      thumbnail_image: "P_TR_thumbnail.png",
      role: "Product Design",
      year: "2021",
      url: "telerehap",
    },
    {
      screen_position: "left",
      project_name: "Taste of Book",
      thumbnail_image: "P_BT_featured.jpg",
      role: "UX/UI design, Branding",
      year: "2019",
      url: "taste-of-book",
    },
    {
      screen_position: "left",
      project_name: "Alice in Dataland",
      thumbnail_image: "P_alice_featured.svg",
      role: "Illustration",
      year: "2018",
      url: "alice",
    },
    {
      screen_position: "left",
      project_name: "Mooovr",
      thumbnail_image: "P_MVR_featured.jpg",
      role: "Web, Branding",
      year: "2017",
      url: "mooovr",
    },
    {
      screen_position: "left",
      project_name: "The Experience elements of F.I.",
      thumbnail_image: "P_FI_featured.jpg",
      role: "Infographic",
      year: "2015",
      url: "experience-elements",
    },
    {
      screen_position: "left",
      project_name: "Nana project 6",
      thumbnail_image: "P_nana6_featured.png",
      role: "Editorial design",
      year: "2010",
      url: "nana",
    },
    {
      screen_position: "left",
      project_name: "Suabow",
      thumbnail_image: "P_SB_featured.png",
      role: "Branding, Character",
      year: "2008",
      url: "suabow",
    },
  ],
};

export { PROJECT_LIST };
